package dev.mmartos.advent

actual fun getPlatform(): Platform = Platform.Web